import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const getTrainingIssueDetail = createAsyncThunk(
  "AgentTrainingIssues/getTrainingIssueDetail",
  async (data, thunkAPI) => {
    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/users/trainingIssues/${data.id}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return resp.data;
    } catch (error) {
      if (error.response) {
        return thunkAPI.rejectWithValue(error.response.data.message);
      } else {
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);

